module.exports = __webpack_public_path__ + "img/img12.baf97c8b.png";